import {
  useCustomerCommunicationPreferenceUpdateMutation,
  CustomerCommunicationPreferenceUpdateMutationOptions,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useCommunicationPreferenceUpdateMutation = (
  baseOptions: CustomerCommunicationPreferenceUpdateMutationOptions,
) => useMutation(useCustomerCommunicationPreferenceUpdateMutation, baseOptions);
